import React, { useState, useEffect } from "react";
import styled from "styled-components";
import alarmSvg from "../../assets/images/alarm.svg";
import userAvi from "../../assets/images/dummyAvi.svg";
import { RxCaretDown } from "react-icons/rx";
import balanceCard from "../../assets/images/card.svg";
import { BsEye, BsEyeSlash } from "react-icons/bs";

import fundBtn from "../../assets/images/fundBtn.svg";
import fundHoverBtn from "../../assets/images/fundHover.svg";
import historyBtn from "../../assets/images/historyBtn.svg";
import historyHoverBtn from "../../assets/images/historyHover.svg";
import { Link, useNavigate } from "react-router-dom";
import FundModal from "./FundModal";
import { toast } from "react-hot-toast";
import { Rings } from "react-loader-spinner";

const Home = () => {
  const [showBalance, setShowBalance] = useState(false);
  const [fundHover, setFundHover] = useState(false);
  const [historyHover, setHistoryHover] = useState(false);
  const [showFundModal, setShowFundModal] = useState(false);
  const [balance, setBalance] = useState();
  const [isVerifying, setIsVerifying] = useState(false);

  const navigate = useNavigate();

  const token = JSON.parse(sessionStorage.getItem("token"));
  const clientId = JSON.parse(sessionStorage.getItem("clientId"));
  const clientId2 = sessionStorage.getItem("clientId2") ? JSON.parse(sessionStorage.getItem("clientId2")) : '';
  useEffect(() => {
    getDashboard();
  }, [token]);

  const urlParams = new URLSearchParams(window.location.search);
  const trxref = urlParams.get("trxref");

  useEffect(() => {
    if (trxref) {
      toast.promise(verifyFund(), {
        pending: "Loading",
        success: "Account Funded Successfully",
        error: "Something went wrong! Please Refresh Page",
      });
    }
  }, [trxref]);

  const getDashboard = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}client/${clientId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      setBalance(data?.data?.wallet?.balance);
    } catch (error) {
    }
  };

  const verifyFund = async () => {
    try {
      setIsVerifying(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/client/fund/${clientId2}/verify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ transactionId: trxref }),
        }
      );
      const data = await response.json();
      setIsVerifying(false);
      if (data.message === "Success") {
        navigate("/account");
        setBalance(data?.data?.wallet?.balance);
      }
      console.log(data);
    } catch (error) {
      console.log(error);
      setIsVerifying(false);
    }
  };

  const ActionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 40px;
    margin-top: 40px;
    gap: 30px;

    @media only screen and (max-width: 450px) {
      padding: 0 10px;
    }

    .fundContainer {
      cursor: pointer;
      img {
        width: 250px;
        transition: all 0.3s ease-in-out;
        @media only screen and (max-width: 450px) {
          width: 160px;
        }
      }
      .fundBtn {
        display: ${fundHover ? "none" : ""};
      }
      .fundHover {
        display: ${!fundHover ? "none" : ""};
      }
    }
    .historyContainer {
      cursor: pointer;
      img {
        width: 250px;
        @media only screen and (max-width: 450px) {
          width: 160px;
        }
      }
      .historyBtn {
        display: ${historyHover ? "none" : ""};
      }
      .historyHover {
        display: ${!historyHover ? "none" : ""};
      }
    }
  `;

  const name = JSON.parse(sessionStorage?.getItem("name"));

  return (
    <Container>
      <div className="head">
        <div className="head_content">
          <img src={alarmSvg} alt="" />
          <div
            className="userProfileWrapper"
            onClick={() => {
              navigate("/dashboard/profile-settings");
            }}
          >
            <img src={userAvi} alt="" />
            <div className="userInfo">
              <p style={{ fontWeight: "bold" }}>{name}</p>
              <p style={{ fontSize: "11px", fontWeight: "bold" }}>User</p>
            </div>
            <RxCaretDown size={17} style={{ color: "#fff" }} />
          </div>
        </div>
      </div>
      <div className="contentWrapper">
        <div className="firstContentHead">
          <p className="pageName">
            Accounts: <em>Wallet Balance</em>
          </p>
        </div>
        <div className="content">
          <div className="balanceView">
            <img src={balanceCard} alt="" />
            <div className="balanceContent">
              <div className="balance_head">
                <p>U-Balance</p>
                <div
                  onClick={() => {
                    setShowBalance(!showBalance);
                  }}
                  className="eyeIcon"
                >
                  {showBalance ? <BsEye /> : <BsEyeSlash />}
                </div>{" "}
              </div>
              <p className="balance">
                ₦{showBalance ? balance?.toLocaleString() : "*********"}
              </p>{" "}
            </div>
          </div>
        </div>

        <ActionWrapper>
          <div
            className="fundContainer"
            onMouseOver={() => {
              setFundHover(true);
            }}
            onMouseLeave={() => {
              setFundHover(false);
            }}
            onClick={() => {
              setShowFundModal(true);
            }}
          >
            <span className="fundBtn">
              <img src={fundBtn} alt="" />
            </span>
            <span className="fundHover">
              <img src={fundHoverBtn} alt="" />
            </span>
          </div>

          <Link to="/account/deposit-history">
            <div
              className="historyContainer"
              onMouseOver={() => {
                setHistoryHover(true);
              }}
              onMouseLeave={() => {
                setHistoryHover(false);
              }}
            >
              <span className="historyBtn">
                <img src={historyBtn} alt="" />
              </span>
              <span className="historyHover">
                <img src={historyHoverBtn} alt="" />
              </span>
            </div>
          </Link>
        </ActionWrapper>
      </div>
      {showFundModal && <FundModal setShowFundModal={setShowFundModal} />}
      {isVerifying && (
        <Rings
          height="80"
          width="80"
          color="#28d1ff"
          radius="6"
          elementStyle={{
            position: "absolute",
            bottom: "0",
          }}
          wrapperStyle={{
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            "background-color": "rgba(0, 0, 0, 0.371)",
            "z-index": "1000",
          }}
          wrapperClass="loadingEl"
          visible={true}
          ariaLabel="rings-loading"
        />
      )}
    </Container>
  );
};

export default Home;

const Container = styled.section`
  padding: 30px;
  position: absolute;
  top: 0;
  width: calc(100% - 16%);
  max-width: calc(100% - 16%);
  @media only screen and (max-width: 1147px) {
    width: calc(100%);
    margin-left: 0;
    max-width: calc(100%);
  }
  @media only screen and (max-width: 450px) {
    padding: 0;
  }

  .head {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .head_content {
      display: flex;
      width: 300px;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;

      @media only screen and (max-width: 450px) {
        width: 150px;
      }

      img {
        @media only screen and (max-width: 450px) {
          width: 20px;
        }
      }

      .userProfileWrapper {
        width: 200px;
        border-left: 1px solid #eeebeb;
        padding-left: 40px;
        display: flex;
        align-items: center;
        gap: 15px;
        cursor: pointer;
        @media only screen and (max-width: 450px) {
          width: 100px;
          padding-left: 0;
          margin-top: 20px;
          border-left: 0 solid #eeebeb;
          /* flex-direction: column; */
        }

        .userInfo {
          display: flex;
          flex-direction: column;
          gap: 15px;
          color: #fff;
          /* align-items: center; */
          p {
            @media only screen and (max-width: 450px) {
              font-size: 11px;
            }
          }
        }
        img {
          @media only screen and (max-width: 450px) {
            width: 40px;
          }
        }

        svg {
          @media only screen and (max-width: 450px) {
            display: none;
          }
        }
      }
    }
  }

  .contentWrapper {
    background-color: #fff;
    padding: 20px;
    border-radius: 20px;
    margin-top: 50px;

    .firstContentHead {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .pageName {
        font-size: 30px;
        @media only screen and (max-width: 450px) {
          font-size: 20px;
        }
        em {
          font-size: 25px;
          @media only screen and (max-width: 450px) {
            font-size: 15px;
          }
        }
      }
      .filterWrapper {
        display: flex;
        align-items: center;
        gap: 15px;

        select {
          border: 1px solid #00000047;
          border-radius: 5px;
          padding: 5px;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 40px;
      margin-top: 40px;

      .balanceView {
        width: 600px;
        position: relative;
        @media only screen and (max-width: 450px) {
          width: 98%;
        }
        img {
          width: 100%;
        }
        .balanceContent {
          position: absolute;
          padding: 0 40px;
          top: 60px;
          width: 100%;

          @media only screen and (max-width: 450px) {
            padding: 0 10px;
            top: 20px;
          }

          .balance_head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #fff;

            p {
              font-size: 25px;
              font-weight: 600;
              @media only screen and (max-width: 450px) {
                font-size: 15px;
              }
            }
            svg {
              font-size: 40px;
              opacity: 0.6;
              cursor: pointer;
              transition: 0.2s ease-out;
              @media only screen and (max-width: 450px) {
                font-size: 22px;
              }
              &:hover {
                opacity: 0.8;
              }
            }
          }

          .balance {
            margin-top: 20px;
            color: #fff;
            font-weight: 600;
            font-size: 45px;
            user-select: none;
            @media only screen and (max-width: 450px) {
              font-size: 19px;
            }
          }
        }
      }
    }
  }
`;
